import React from "react";
import { Helmet } from 'react-helmet-async';
import { BuildAbsoluteUrl } from "../utils/urlBuilder";

const SeoBlock = ({routeData}) => {
    if (!routeData) return null;

    const {canonical_url, meta_title, meta_keywords, meta_description, url_key} = routeData;
    let baseImage = 'https://s3.emmezeta.hr/media/emmezeta.png';
    const canonicalUrl = BuildAbsoluteUrl(canonical_url ? canonical_url : url_key);
    let type="website"

    // Sprawdź czy to strona z formularzem pytań - nie powinna być indeksowana
    const isQuestionForm = url_key && url_key.startsWith('emmezeta-pitanja-o-proizvodu');
    switch (routeData.__typename) {
        case 'CategoryTree':
            const storePath = routeData.current_store_paths && routeData.current_store_paths[0];
            const baseUrlImage = storePath && storePath.base_url_image;
            if (baseUrlImage) {
                baseImage = baseUrlImage;
            }
            break;
        case 'SimpleProduct':
        case 'GroupedProduct':
            const { gallery } = routeData || {};
            const firstImage = gallery && gallery.length && gallery.reduce((prev, curr) => (prev.position < curr.position ? prev : curr));
            const image = firstImage && firstImage.url ;
            if (image) {
                baseImage = image;
            }
            type="product"
            break;
        case 'CmsPage':
            type="article"
            break;
    }
    
    return (
            <Helmet>
                {isQuestionForm && <meta name="robots" content="noindex, nofollow" />}

                {meta_title && <title>{meta_title}</title>}
                {meta_description && <meta name="description" content={meta_description}/>}
                {meta_keywords && <meta name="keywords" content={meta_keywords}/>}
                {canonicalUrl && !isQuestionForm && <link rel="canonical" href={canonicalUrl}/>}
                {meta_title && <meta property="og:title" content={meta_title}/>}
                {meta_description && <meta property="og:description" content={meta_description}/>}
                {canonicalUrl && <meta property="og:url" content={canonicalUrl}/>}
                {baseImage && <meta property="og:image" content={baseImage}/>}
                {baseImage && <meta property="og:type" content={type}/>}
            </Helmet>
        );
}

export default SeoBlock